webpackJsonp([11],{

/***/ 491:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(746)
}
var Component = __webpack_require__(182)(
  /* script */
  __webpack_require__(748),
  /* template */
  __webpack_require__(749),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-56857d9e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 498:
/***/ (function(module, exports) {

exports.detectUa = function () {
    var browers = {};
    var ua = navigator.userAgent.toLowerCase();
    browers.iPad = ua.match(/ipad/);
    browers.iPhone = ua.match(/iphone/);
    browers.isAndroid = ua.match(/android/);
    browers.isiOS = ua.match(/ipad|iphone|ios/);
    browers.isDesktop = !browers.isiOS && !browers.isAndroid;
    browers.ie = ua.match(/iemobile/);
    browers.isWifi = ua.match(/nettype\/wifi|technology\/wifi/);
    browers.force_ssl = ua.match(/Android (5|6)/i);
    browers.is_ios_6 = ua.match(/iOS 6/i);
    browers.is_liveapp = ua.match(/LiveApp/i);
    return browers;
};

exports.jumpUrl = function (is_apk) {
    ga('send', 'event', 'app', 'download', location.pathname, 1);
    var isiOS = navigator.userAgent.match('iPad') || navigator.userAgent.match('iPhone') || navigator.userAgent.match('iPod'),
        isAndroid = navigator.userAgent.match('Android'),
        isDesktop = !isiOS && !isAndroid;
    function getCookie(name) {
        var arr,
            reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        } else {
            return null;
        }
    }
    function jumpDownload(android_url, ios_url) {
        if (isAndroid) {
            location.href = android_url;
        } else if (isiOS) {
            location.href = ios_url;
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadCom(android_url, ios_url) {
        if (isAndroid) {
            var apk = location.href = '/download';
            var google_play = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
            adroidDownload(apk, google_play);
        } else if (isiOS) {
            location.href = 'https://go.onelink.me/app/ff33e3d5';
        } else if (isDesktop) {
            location.href = 'http://www.allfootballapp.com/home';
        }
    }

    function jumpDownloadPopup() {
        if (isAndroid) {
            return '/download';
        } else if (isiOS) {
            return 'https://go.onelink.me/1751978436?pid=M_FB';
        } else if (isDesktop) {
            return 'http://www.allfootballapp.com/home';
        }
    }

    function adroidDownload(apk, google_play) {
        console.log('随机方法');
        if (Math.random() >= 0.5) {
            location.href = apk;
        } else {
            location.href = google_play;
        }
    }
    goog_snippet_vars = function goog_snippet_vars() {
        var w = window;
        w.google_conversion_id = 838643918;
        w.google_conversion_label = 'ds1fCN_xrHkQzuHyjwM';
        w.google_remarketing_only = false;
    };

    function goog_report_conversion(url) {
        var isOperaMini = navigator.userAgent.indexOf('Opera Mini');
        console.log('isOperaMini', isOperaMini);
        goog_snippet_vars();
        window.google_conversion_format = '3';
        var opt = new Object();
        opt.onload_callback = function () {
            if (typeof url !== 'undefined') {
                console.log('url2', url);
                if (isAndroid) {
                    window.location = 'market://details?id=com.allfootball.news';
                    setTimeout(function () {
                        console.log('跳转GP失败');
                        window.location = url;
                    }, 1000);
                    return;
                }
                window.location = url;
            }
        };
        var conv_handler = window['google_trackConversion'];
        if (typeof conv_handler === 'function') {
            if (isOperaMini >= 0) {
                console.log('url', url);
                window.location = url;
            } else {
                conv_handler(opt);
            }
        }
    }
    var utm_source = getCookie('utm_source');
    var utm_campaign = getCookie('utm_campaign');
    var search = (location.search || '').slice(1);
    if (utm_source === 'google_search' && utm_campaign === 'EPL') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'La Liga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Bundesliga') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Serie A') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'google_search' && utm_campaign === 'Transfers') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (utm_source === 'UC-Browser' && utm_campaign === 'p20') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else if (location.pathname === '/downloadCoin' || search.indexOf('utm_source=shareForAFCoin') > -1 || utm_source === 'shareForAFCoin') {
        var android_url = 'https://oss-public.allfootballapp.com/apk/allfootball-368.apk';
        var ios_url = 'https://go.onelink.me/app/ff33e3d5';
        jumpDownload(android_url, ios_url);
    } else {
        if (is_apk) {
            if (location.hostname === 'm.all.football') {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            } else {
                goog_report_conversion('https://oss-public.allfootballapp.com/apk/allfootball-368.apk');
            }
        } else {
            var url = jumpDownloadPopup();
            console.log('ios的url', url);
            location.href = url;
            goog_report_conversion(url);
        }
    }
};

exports.lazyload = function (id, classImg) {
    var listwrap = document.getElementById(id);
    if (listwrap) {
        var teamLogo = document.getElementsByClassName(classImg);
        var windowH = window.innerHeight;
        var offsetY = window.pageYOffset;
        for (var i = 0; i < teamLogo.length; i++) {
            var iT = teamLogo[i].getBoundingClientRect().top;
            if (iT < windowH + offsetY + windowH * 3 / 4) {
                if (teamLogo[i].getAttribute('data-src')) {
                    teamLogo[i].src = teamLogo[i].getAttribute('data-src');
                    teamLogo[i].removeAttribute('data-src');
                }
            }
        }
    }
};

exports.timeForInOut = function () {};

exports.checkOperamini = function () {
    var isOperaMini = navigator.userAgent.indexOf('Opera Mini') > -1;
    return isOperaMini;
};

exports.record = function (url) {
    var prefix = '//stat.allfootballapp.com';
    var newImage = new Image();
    newImage.src = prefix + '/' + url;
    return newImage;
};

exports.getQueryString = function (name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]);
    return null;
};

/***/ }),

/***/ 515:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(516);


/***/ }),

/***/ 516:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g =
  typeof global === "object" ? global :
  typeof window === "object" ? window :
  typeof self === "object" ? self : this;

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(185);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),

/***/ 517:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(124);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),

/***/ 746:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(747);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(84)("1157e396", content, true);

/***/ }),

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(83)(true);
// imports


// module
exports.push([module.i, ".main[data-v-56857d9e]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif!important}img[data-v-56857d9e]{display:block;margin:0}.downloaarticle-main-title[data-v-56857d9e]{padding-bottom:22px;margin-top:25px;color:#16ac3a;font-size:31px;font-weight:800;text-align:center}.download-article-bold[data-v-56857d9e]{display:inline-block;width:270px;margin-bottom:17px}.download-title[data-v-56857d9e]{width:175px;margin:0 auto;margin-top:10px}.downloaarticle-title[data-v-56857d9e]{font-family:Helvetica Neue,Helvetica,Arial,sans-serif!important;padding:22px 0;color:#16ac3a;font-size:24px;font-weight:800;text-align:center}.downloaarticle-title[data-v-56857d9e]:first-of-type{border-top:1px solid #f4f6f8}.download-btn[data-v-56857d9e]{width:150px;height:45px;margin:0 auto;margin-bottom:20px;margin-top:10px}.download-article[data-v-56857d9e]{padding:0 10px 10px;color:#2d2f32;font-size:16px;text-align:center}.download-article[data-v-56857d9e]:first-of-type{padding:0 10px 26px}.download-article .green[data-v-56857d9e]{color:#16ac3a}.download-bottom[data-v-56857d9e]{background:#eff1f4;margin-top:-1px}", "", {"version":3,"sources":["/home/work/jenkins/workspace/prod-allfootball-msite/src/pages/AppDownload.vue"],"names":[],"mappings":"AACA,uBACI,+DAAuE,CAC1E,AACD,qBACI,cAAe,AACf,QAAU,CACb,AACD,4CACI,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,wCACI,qBAAsB,AACtB,YAAa,AACb,kBAAoB,CACvB,AACD,iCACI,YAAa,AACb,cAAe,AACf,eAAiB,CACpB,AACD,uCACI,gEAAuE,AACvE,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACtB,AACD,qDACI,4BAA8B,CACjC,AACD,+BACI,YAAa,AACb,YAAa,AACb,cAAe,AACf,mBAAoB,AACpB,eAAiB,CACpB,AACD,mCACI,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACtB,AACD,iDACI,mBAA0B,CAC7B,AACD,0CACI,aAAe,CAClB,AACD,kCACI,mBAAoB,AACpB,eAAiB,CACpB","file":"AppDownload.vue","sourcesContent":["\n.main[data-v-56857d9e] {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n}\nimg[data-v-56857d9e] {\n    display: block;\n    margin: 0;\n}\n.downloaarticle-main-title[data-v-56857d9e] {\n    padding-bottom: 22px;\n    margin-top: 25px;\n    color: #16ac3a;\n    font-size: 31px;\n    font-weight: 800;\n    text-align: center;\n}\n.download-article-bold[data-v-56857d9e] {\n    display: inline-block;\n    width: 270px;\n    margin-bottom: 17px;\n}\n.download-title[data-v-56857d9e] {\n    width: 175px;\n    margin: 0 auto;\n    margin-top: 10px;\n}\n.downloaarticle-title[data-v-56857d9e] {\n    font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif !important;\n    padding: 22px 0;\n    color: #16ac3a;\n    font-size: 24px;\n    font-weight: 800;\n    text-align: center;\n}\n.downloaarticle-title[data-v-56857d9e]:first-of-type {\n    border-top: 1px solid #f4f6f8;\n}\n.download-btn[data-v-56857d9e] {\n    width: 150px;\n    height: 45px;\n    margin: 0 auto;\n    margin-bottom: 20px;\n    margin-top: 10px;\n}\n.download-article[data-v-56857d9e] {\n    padding: 0 10px 10px;\n    color: #2d2f32;\n    font-size: 16px;\n    text-align: center;\n}\n.download-article[data-v-56857d9e]:first-of-type {\n    padding: 0 10px 26px 10px;\n}\n.download-article .green[data-v-56857d9e] {\n    color: #16ac3a;\n}\n.download-bottom[data-v-56857d9e] {\n    background: #eff1f4;\n    margin-top: -1px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 748:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__util_util__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            is_opreamini: false
        };
    },
    mounted: function mounted() {
        Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["record"])('msite/download?from=' + Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["getQueryString"])('from'));
        ga('send', 'event', 'downloadPage', 'enter', Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["getQueryString"])('from'));
        var utilObj = __webpack_require__(498);
        if (!utilObj.checkOperamini()) {
            this.jumpUrl();
        }
        this.is_opreamini = utilObj.checkOperamini();

        var isTryAwakeUp = Object(__WEBPACK_IMPORTED_MODULE_3__util_util__["getQueryString"])('type').startsWith('allfootball');
        if (!isTryAwakeUp) return;

        this.fallbackToApp();
    },


    methods: {
        jumpUrl: function jumpUrl() {
            var utilObj = __webpack_require__(498);
            utilObj.jumpUrl(true);
        },
        sleep: function sleep(ms) {
            return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve) {
                return setTimeout(resolve, ms);
            });
        },
        fallbackToApp: function fallbackToApp() {
            var _this = this;

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
                var userAgent, isIos, url;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return _this.sleep(25);

                            case 2:
                                userAgent = navigator.userAgent.toLowerCase();
                                isIos = /iphone|ipad|ipod|ios/.test(userAgent);

                                if (isIos) {
                                    _context.next = 6;
                                    break;
                                }

                                return _context.abrupt('return');

                            case 6:
                                url = 'https://apps.apple.com/id/app/all-football-scores-news/id1171012600';

                                window.location.href = url;

                                _context.next = 10;
                                return _this.sleep(1200);

                            case 10:
                                window.history.go(-1);

                            case 11:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, _this);
            }))();
        }
    }
});

/***/ }),

/***/ 749:
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h1', {
    staticClass: "downloaarticle-main-title"
  }, [_vm._v("Congratulations!")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You have downloaded All Football App, which is the updated version of this website and will provide you with\n        better using experience.\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("1. Download the app")]), _vm._v(" "), (!_vm.is_opreamini) ? _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        If you accidentally cancel the download, you can click on the link below to re-download it.\n    ")]) : _vm._e(), _vm._v(" "), _c('img', {
    staticClass: "download-btn",
    attrs: {
      "src": __webpack_require__(750)
    },
    on: {
      "click": _vm.jumpUrl
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(751),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("2. Adjust the phone's setup")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(752),
      "alt": ""
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("3. Install the app")]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(753),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(4)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_c('b', {
    staticClass: "download-article-bold"
  }, [_vm._v("Below are some introductions to how to install our App.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        If the usual warning about possible device damage appears, confirm "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"OK\"")]), _vm._v(" - we guarantee\n        that our app will definitely not harm your device.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You'll find the downloaded app in "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifications\"")]), _vm._v(" or in the "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Download\"")]), _vm._v(" folder. Click on it, choose "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Install\"")]), _vm._v(" and confirm.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n        You'll find the downloaded app in "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Notifications\"")]), _vm._v(" or in the "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Download\"")]), _vm._v(" folder. Click on it, choose "), _c('b', {
    staticClass: "green"
  }, [_vm._v("\"Install\"")]), _vm._v(" and confirm.\n    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "download-bottom"
  }, [_c('h2', {
    staticClass: "downloaarticle-title"
  }, [_vm._v("Did not work?")]), _vm._v(" "), _c('p', {
    staticClass: "download-article"
  }, [_vm._v("\n            Try it once again following the instructions above. Or download the latest app version from "), _c('a', {
    attrs: {
      "href": "https://at.umeng.com/SbK5Lf"
    }
  }, [_c('b', {
    staticClass: "green"
  }, [_vm._v("Google_Play")])]), _vm._v(".\n        ")])])
}]}

/***/ }),

/***/ 750:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_btn.348b20d.png";

/***/ }),

/***/ 751:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic1.eafcd28.png";

/***/ }),

/***/ 752:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic2.b951f50.png";

/***/ }),

/***/ 753:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/download_pic3.844e103.png";

/***/ })

});


// WEBPACK FOOTER //
// static/js/11.869cfb049c51c59e5840.js